import {
    HttpErrorResponse,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/observable/throw'
import 'rxjs/add/operator/catch'
import { GestorDeErros } from '../core/gestor-de-erros'

@Injectable()
export class NotAuthorizedInterceptor implements HttpInterceptor {
    constructor(private gestorDeErros: GestorDeErros) {}

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        return next.handle(req).catch((error) => {
            if (error instanceof HttpErrorResponse) {
                this.gestorDeErros.tratarHttpResponseError(error)
            }

            return Observable.throw(error)
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/authentication/not-authorized-interceptor.ts